import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation, Link } from 'react-router-dom';
import { useAuthStore } from './store/authStore';
import { useCartStore } from './store/cartStore';

import Header from './components/Header';
import Footer from './components/Footer';
import CartDrawer from './components/CartDrawer';
import Home from './pages/Home';
import Products from './pages/Products';
import ProductDetail from './pages/ProductDetail';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import Login from './pages/Auth/Login';
import Register from './pages/Auth/Register';
import Profile from './pages/Profile';
import Orders from './pages/Orders';
import OrderDetail from './pages/OrderDetail';

import { StoreSettingsProvider } from './context/StoreSettingsContext';
import { ProductPriceProvider } from './context/ProductPriceContext';
import WhatsAppButton from './components/WhatsAppButton';
import Wishlist     from './pages/Wishlist';
import NewArrivals  from './pages/NewArrivals';
import Deals        from './pages/Deals';
import MostSelling  from './pages/MostSelling';
import AboutUs      from './pages/AboutUs';
import Contact      from './pages/Contact';
import './App.css';

function UnderDev() {
  return (
    <div style={{ minHeight: 'calc(100vh - 140px)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: '40px 20px', animation: 'under-dev-in 0.6s cubic-bezier(0.34,1.56,0.64,1) both' }}>
      <div style={{ fontSize: '4rem', marginBottom: 20, display: 'inline-block', animation: 'icon-bob 2.4s ease-in-out infinite' }}>🚧</div>
      <h1 style={{ fontSize: 'clamp(1.8rem,4vw,2.6rem)', fontWeight: 900, color: '#0f1f3d', letterSpacing: '-0.02em', marginBottom: 12 }}>Under Development</h1>
      <p style={{ fontSize: '1rem', color: '#64748b', lineHeight: 1.7, marginBottom: 32 }}>This feature is currently being built.<br />Check back soon!</p>
      <Link to="/" style={{ display: 'inline-flex', alignItems: 'center', padding: '13px 32px', background: 'var(--primary)', color: '#fff', fontWeight: 700, fontSize: '0.9375rem', borderRadius: 12, textDecoration: 'none', boxShadow: '0 4px 20px rgba(240,180,41,0.35)' }}>Back to Home</Link>
    </div>
  );
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  const { token, getCurrentUser } = useAuthStore();
  const { drawerOpen, closeDrawer, fetchCart } = useCartStore();
  useEffect(() => { if (token) getCurrentUser(); }, [token, getCurrentUser]);
  useEffect(() => { fetchCart(); }, []);

  return (
    <StoreSettingsProvider>
    <ProductPriceProvider>
    <BrowserRouter>
      <ScrollToTop />
      <CartDrawer open={drawerOpen} onClose={closeDrawer} />
      <Header />
      <WhatsAppButton />
      <main className="main-content">
        <Routes>
          <Route path="/"             element={<Home />} />
          <Route path="/products"     element={<Products />} />
          <Route path="/products/:id" element={<ProductDetail />} />
          <Route path="/cart"         element={<Cart />} />
          <Route path="/checkout"     element={<Checkout />} />
          <Route path="/wishlist"     element={<Wishlist />} />
          <Route path="/login"        element={!token ? <Login />      : <Navigate to="/" />} />
          <Route path="/register"     element={!token ? <Register />   : <Navigate to="/" />} />
          <Route path="/profile"      element={token ? <Profile />     : <Navigate to="/login" />} />
          <Route path="/orders"       element={token ? <Orders />      : <Navigate to="/login" />} />
          <Route path="/orders/:id"    element={token ? <OrderDetail /> : <Navigate to="/login" />} />
          <Route path="/new-arrivals"   element={<NewArrivals />} />
          <Route path="/deals"          element={<Deals />} />
          <Route path="/most-selling"   element={<MostSelling />} />
          <Route path="/about"          element={<AboutUs />} />
          <Route path="/contact"        element={<Contact />} />
        </Routes>
      </main>
      <Footer />
    </BrowserRouter>
    </ProductPriceProvider>
    </StoreSettingsProvider>
  );
}

export default App;
